export const formatDate = (dateStr) => {
  const [day, month, year] = dateStr.split("/");
  if (!day || !month || !year) return null;

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

export const removeAmPm = (timeStr) => {
  if (!timeStr || typeof timeStr !== "string") return null;

  const parts = timeStr.trim().split(" ");
  if (parts.length !== 2) return null;

  const time = parts[0];
  const modifier = parts[1]?.toUpperCase();

  if (!time || !modifier || (modifier !== "AM" && modifier !== "PM"))
    return null;

  let [hours, minutes] = time.split(":");

  // Handle case like "11 AM" (no minutes provided)
  hours = parseInt(hours, 10);
  minutes = minutes ? minutes : "00";

  if (isNaN(hours) || isNaN(parseInt(minutes))) return null;

  if (modifier === "PM" && hours < 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

// export const formatTime = (time) => {
//   if (!time) return "";

//   time = time
//     .trim()
//     .toUpperCase()
//     .replace(/\s+/g, " ")
//     .replace(/\s*:\s*/g, ":")
//     .replace(/\s*(AM|PM)/, " $1");

//   if (/^\d{1,2}:\d{2} (AM|PM)$/.test(time)) {
//     return time;
//   }

//   if (/^\d{1,2} (AM|PM)$/.test(time)) {
//     return time.replace(/(AM|PM)$/,":00 $1");
//   }

//   return time;
// };

export const formatTime = (time) => {
  if (!time) return "";

  time = time
    .trim()
    .toUpperCase()
    .replace(/[\s\u00A0]+/g, " ")
    .replace(/\s*:\s*/g, ":")
    .replace(/\s*(AM|PM)$/, " $1");

  if (/^\d{1,2}:\d{2} (AM|PM)$/.test(time)) {
    const [hourMin, period] = time.split(" ");
    const [hour, min] = hourMin.split(":");
    return `${hour.padStart(2, "0")}:${min} ${period}`;
  }

  if (/^\d{1,2} (AM|PM)$/.test(time)) {
    const [hour, period] = time.split(" ");
    return `${hour.padStart(2, "0")}:00 ${period}`;
  }

  return time;
};
